








































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import TabView from '@/components/TabView.vue';
import TabItem from '@/components/TabItem.vue';
import TextHeader from '@/components/TextHeader.vue';

export default Vue.extend({
    name: 'reference-x1',
    components: { TabView, TabItem, TextHeader },
    data() : { visible: boolean } { return { visible: true }; },
});
